import {PageBody} from '@components/ui/page-atoms/PageAtoms.tsx'
import {Header} from '@components/commons/header/Header.tsx'
import {Divider} from '@components/ui/divider/Divider.tsx'
import {Outlet} from 'react-router-dom'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'
import {StyledProjectsRoute} from './style'

export const ProjectsRoute = () => {
    const permissions = usePermissions()

    if (!permissions?.projects?.read) {
        return <NoPermissionBox />
    }

    return (
        <PageBody>
            <Header />
            <Divider direction="horizontal" />
            <StyledProjectsRoute>
                <Outlet />
            </StyledProjectsRoute>
        </PageBody>
    )
}
